angular.module('properties.dataCollectors')
    .filter('collectorIdentifierName', function($filter) {
        return function(collectorClass, options) {
            if (!collectorClass) return 'Serial number';

            var identifierName = _.find(options.collectorClasses, { 'name': collectorClass });
            return textural(identifierName.identifierName).format('capitalizehuman').replace('id', 'Id');
        }
    });